import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import useMeetingTypes from './useMeetingTypes';

const useSingleAsset = () => {
  const { id: routeId } = useParams();
  const { singleItem, loading } = useMeetingTypes(false);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleAsset;
